<template>
  <div id="deposit-receipt">

    <vs-alert color="warning" class="mb-4" active="true" v-if="!Receipt.status">
      {{$t('Deposit via receipt is disabled')}}
    </vs-alert>

    <vs-alert color="warning" class="mb-4" active="true" v-else-if="activeUserInfo.level<5">
      {{$t('Only for level 5 it is possible to deposit with a receipt.')}}
    </vs-alert>

    <vs-alert color="warning" class="mb-4" active="true" v-else-if="Receipt.alert && Receipt.alert !=''">
      {{$t(Receipt.alert)}}
    </vs-alert>

    <vs-alert color="warning" class="mb-4" active="true" v-else-if="wallet.internal.name=='toman'">
      {{$t('You must make a deposit from approved bank accounts.')}}
    </vs-alert>

    <form autocomplete="off" :class="!Receipt.status||activeUserInfo.level<5? 'disable-block':''" v-on:submit.prevent="submitFormDeposit()">

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <div class="lg:mt-3">{{$t('Amount')}}</div>
        </div>
        <div class="vx-col sm:w-2/3 w-full relative">
          <vs-input class="w-full vazir" icon-pack="feather" icon-no-border icon="icon-hash" v-model="amount" maxlength="20"
                    v-validate="'required'" :class="errors.has('amount') && depositSubmit ? 'border-danger':'' " name="amount" />
          <span class="label-absolute capitalize">{{$t(wallet.internal.name)}}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <div class="lg:mt-3">{{$t('Payer account')}}</div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <div class="vx-col w-full">
            <vs-select class="w-full" name="card" v-validate="'required'" v-model="card" :placeholder="$t('Select bank account')"
                       :descriptionText="$t('See the list of your approved bank accounts')" :class="errors.has('card') && depositSubmit ? 'border-danger':''">
              <vs-select-item :key="index" :value="item.id" :text="item.card +' ' + item.bank" v-for="(item,index) in listCards" />
            </vs-select>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <div class="lg:mt-3">{{$t('Payee account')}}</div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <div class="vx-col w-full">
            <p class="mb-3">{{$t('See our list of bank accounts')}}:</p>
            <ul>
              <li v-for="(item,index) in Receipt.list_cards" v-if="item.name_bank" class="mb-1 border border-solid border-t-0 border-r-0 border-l-0 mb-4 pb-4">
                <vs-radio v-model="payee" :vs-value="item.iban_number" name="payee" v-validate="'required'" :data-vv-as="$t('Payee account')" >
                  <div class="mb-1">{{$t('Account number')}}: {{item.account_number}} {{item.name_bank}}</div>
                  <div>{{item.iban_number}}</div>
                </vs-radio>
              </li>
            </ul>
            <span class="text-danger text-sm" v-show="errors.has('payee') && depositSubmit">{{ errors.first('payee') }}</span>

          </div>
        </div>
      </div>


      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <div class="lg:mt-3">{{$t('Tracking Code')}}</div>
        </div>
        <div class="vx-col sm:w-2/3 w-full relative">
          <vs-input class="w-full vazir" icon-pack="feather" icon-no-border icon="icon-command" v-model="trackingCode"
                    v-validate="'required'" :class="errors.has('amount') && depositSubmit ? 'border-danger':'' " name="amount" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <div :class="islocale=='fa' ?'lg:mt-3':''">{{$t('Date and time of the transaction')}}</div>
        </div>
        <div class="vx-col sm:w-2/3 w-full relative">
          <vs-input v-model="dateTime" id="dateTime" name="dateTime" class="w-full vazir" icon-pack="feather" icon-no-border icon="icon-calendar"
                    :class="[$vs.rtl ? 'rtl' : 'ltr' , errors.has('dateTime') && depositSubmit ? 'border-danger':'' ]" v-validate="'required'" @focus="showDatePicker = true"
                    val-icon-success="icon-check" val-icon-warning="icon-clock" val-icon-pack="feather"/>
          <span class="text-danger text-sm" v-show="errors.has('BaseData.dateBirth') && depositSubmit">{{ errors.first('BaseData.dateBirth') }}</span>
          <date-picker v-model="dateTime" :show="showDatePicker" @close="showDatePicker=false" :auto-submit="true" color="rgba(var(--vs-primary), 1)"
                       type="datetime" :locale="locale" :locale-config="localeConfig" :format="(islocale=='fa')?'jYYYY/jMM/jDD HH:mm' : 'YYYY-MM-DD HH:mm'" element="dateTime">
          </date-picker>
        </div>
      </div>


      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <div class="lg:mt-3">{{$t('How to deposit')}}</div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <div class="vx-col w-full">
            <vs-select class="w-full" name="via" v-validate="'required'" v-model="via" :placeholder="$t('Choose how to deposit')"
                       :class="errors.has('via') && depositSubmit ? 'border-danger':''">
              <vs-select-item :key="index" :value="item.name" :text="item.name" v-if="item.name" v-for="(item,index) in Receipt.via" />
            </vs-select>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <div class="lg:mt-3">{{$t('Photo Receipt(optional)')}}</div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <div class="vx-col w-full">
            <vs-input type="file" class="w-full" icon-pack="feather" icon-no-border icon="icon-upload"
                      v-model="file" :descriptionText="$t('Optional and to speed up transaction confirmation time')"
                      data-vv-as="file" :class="errors.has('file') && depositSubmit ? 'border-danger':''" name="file" id="file" ref="file" accept="image/*,.pdf"/>
            <span class="text-danger text-sm" v-show="errors.has('file') && depositSubmit">{{ errors.first('file') }}</span>
          </div>
        </div>
      </div>

      <transition name="slide">
        <div class="w-full flex px-3" v-if="uploadPercentage > 0 && file">
          <p class="mr-3 text-center">{{uploadPercentage}}%</p>
          <vs-progress class="mt-1" :height="12" :percent="uploadPercentage" color="success"></vs-progress>
        </div>
      </transition>

      <div class="vx-row">
        <div class="vx-col sm:w-1/3 w-full">
          <div class="lg:mt-3"></div>
        </div>
        <div class="vx-col sm:w-2/3 w-full flex">
          <vs-button class="mr-3 mb-2" icon-pack="feather" icon="icon-check" :disabled="isLoading"
                     :id="'button-payment-receipt'" @click.prevent="submitFormDeposit">
            {{$t('Submit information')}}
          </vs-button>
          <vs-button color="dark" type="border" class="mb-2 " :to="'/wallets'">بازگشت</vs-button>
        </div>
      </div>
    </form>
  </div>
</template>
<i18n locale="fa">
{
  "You must make a deposit from approved bank accounts.":
    "واریز را می بایست از حساب های بانکی تایید شده انجام دهید."

  ,"Payer account": "پرداخت کننده"
  ,"Payee account": "حساب دریافت کننده"
  ,"Select bank account": "انتخاب حساب بانکی"
  ,"Deposit via receipt is disabled": "واریز از طریق فیش غیر فعال است."
  ,"See the list of your approved bank accounts": "لیست حساب بانکی های تایید شده خودتان را میبینید"
  ,"Tracking Code": "کد رهگیری"
  ,"Date and time of the transaction": "تاریخ و زمان تراکنش"
  ,"How to deposit": "نحوه واریز"
  ,"Choose how to deposit": "نحوه واریز را انتخاب کنید"
  ,"Account number": "شماره حساب"
  ,"See our list of bank accounts": "لیست حساب بانکی های ما را میبینید"
  ,"Optional and to speed up transaction confirmation time":"اختیاری و جهت سرعت بخشیدن به زمان تایید تراکنش"
  ,"Photo Receipt(optional)":"تصویر رسید (اختیاری)"
  ,"Only for level 5 it is possible to deposit with a receipt.":"فقط برای سطح ۵ امکان واریز با فیش وجود دارد."

}
</i18n>
<script>
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
    import axios from "../../../../http/axios";


    export default {
      name: "PaymentGateway",
      props: ['wallet','listGatway','listCards','Receipt'],
      components:{
        datePicker: VuePersianDatetimePicker,
      },
      data () {
        return {
          isLoading:false,
          depositSubmit:false,
          amount:'',
          payee:'',
          trackingCode:'',
          card:null,
          via:null,

          file:null,
          uploadPercentage:0,

          dateTime:'',
          showDatePicker: false,
          localeConfig:{
            fa: {
              dow: 6,     //  first day of week
              dir: 'rtl',
              displayFormat: 'jYYYY/jMM/jDD'
            },
            en: {
              dow: 0,
              dir: 'ltr',
              displayFormat: 'YYYY-MM-DD'
            }
          },
        }
      },
      methods:{
        submitFormDeposit(){
          this.$validator.validateAll().then(result => {
              if (result) {

                this.$vs.loading({
                  container: '#button-payment-receipt',
                  scale: 0.65
                })
                var file = document.getElementById('file').files[0];
                const bodyFormData = new FormData();
                bodyFormData.append('amount', this.amount.replace(/[^\d.-]/g, ''))
                bodyFormData.append('payee', this.payee)
                bodyFormData.append('trackingCode', this.trackingCode)
                bodyFormData.append('card', this.card)
                bodyFormData.append('viaPay', this.via)
                bodyFormData.append('dateTime', this.dateTime)
                if(file)
                  bodyFormData.append('file', file)

                var self = this;
                axios.post('/wallets/internal/deposit/receipt', bodyFormData,{
                  onUploadProgress: function( progressEvent ) {
                    this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                  }.bind(this)
                })
                  .then(function (response) {
                    if (response.data.status == true) {
                      self.$swal({
                        icon: 'success',
                        title: self.$t('Success'),
                        text: response.data.msg
                      })
                      Object.assign(self.$data, self.$options.data.apply(self))
                      self.$refs.file.reset();
                      self.depositSubmit = false
                    } else {
                      self.$vs.notify({title: self.$t('Error'), text: response.data.msg, iconPack: 'feather', icon: 'icon-alert-circle', color: 'danger'})
                    }
                    self.uploadPercentage = 0;
                    self.$vs.loading.close('#button-payment-receipt > .con-vs-loading'); self.isLoading = false;
                  })
                  .catch(function (error) {
                    self.handelerErrorApi(error);
                    self.uploadPercentage = 0;
                    self.$vs.loading.close('#button-payment-receipt > .con-vs-loading'); self.isLoading = false;
                  })
              }else
                this.depositSubmit = true
          })
        }
      },
      watch:{
        amount(value){
          this.amount = this.amountLocalFloat(value,this.wallet.internal.percent)
        }
      },
      computed:{

      },
      mounted() {
      },
      created() {
        //this.locale = this.$i18n.locale;
        this.payee = this.Receipt.list_cards[0].iban_number
      }
    }
</script>

<style lang="scss">
  #deposit-receipt{
    .label-absolute{
      position: absolute;
      right: 22px;
      top: 10px;
      padding-left: 5px;
    }
  }
</style>
